<div class="icon">
    <dtm-ui-icon name="information-fill"></dtm-ui-icon>
</div>
<div class="content">
    <ng-content></ng-content>
</div>
